// Attaches a scroll ref to the thread body and pins the message matching
// `trigger` to the top whenever the trigger changes. The DOM node is
// located via the `data-message-id` attribute set by ThreadBody — see
// scrollUtils for the math.

import { useEffect, useRef } from 'react';
import { scrollMessageToTop } from '../utils/scrollUtils';

interface UseThreadScrollOptions {
  /**
   * Id of the message whose top should align to the container's top.
   * Pass the latest user-message id — each new user turn pins itself to
   * the top so the user can read the assistant reply downward.
   */
  trigger: string | null;
}

interface UseThreadScrollReturn {
  scrollRef: React.RefObject<HTMLDivElement>;
}

export const useThreadScroll = ({
  trigger,
}: UseThreadScrollOptions): UseThreadScrollReturn => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = scrollRef.current;
    if (!root || !trigger) return;
    const target = root.querySelector<HTMLElement>(
      `[data-message-id="${trigger}"]`
    );
    if (!target) return;
    scrollMessageToTop(root, target);
  }, [trigger]);

  return { scrollRef };
};
